import { isEdgeHubQueryParamPresent } from '../lib/urlParserUtils'

export function addScriptToBody(src: string): Promise<void> {
  const s = document.createElement('script')

  if (window.__STATIC_URL_POLICY__ && isEdgeHubQueryParamPresent()) {
    s.src = window.__STATIC_URL_POLICY__.createScriptURL(src)
  } else {
    s.src = src
  }

  return new Promise<void>((resolve: () => void, _reject: (errorText: string) => void) => {
    s.onload = () => {
      resolve()
    }
    document.body.appendChild(s)
  })
}
